import type { CSSProperties } from 'react';

type PrismStyle = { [key: string]: CSSProperties };

export const prismDark: PrismStyle = {
	'code[class*="language-"]': {
		color: '#E5E7EB',
		background: 'transparent',
		fontFamily:
			'var(--font-jetbrains-mono, var(--font-mono, ui-monospace)), monospace',
		fontSize: '13px',
		lineHeight: '1.7',
		direction: 'ltr',
		textAlign: 'left',
		whiteSpace: 'pre',
		wordSpacing: 'normal',
		wordBreak: 'normal',
		tabSize: 4,
		hyphens: 'none',
	},
	'pre[class*="language-"]': {
		color: '#E5E7EB',
		background: 'transparent',
		fontFamily:
			'var(--font-jetbrains-mono, var(--font-mono, ui-monospace)), monospace',
		fontSize: '13px',
		lineHeight: '1.7',
		direction: 'ltr',
		textAlign: 'left',
		whiteSpace: 'pre',
		wordSpacing: 'normal',
		wordBreak: 'normal',
		tabSize: 4,
		hyphens: 'none',
		padding: 0,
		margin: 0,
		overflow: 'auto',
	},
	comment: { color: '#6B7280', fontStyle: 'italic' },
	prolog: { color: '#6B7280' },
	doctype: { color: '#6B7280' },
	cdata: { color: '#6B7280' },
	punctuation: { color: '#D1D5DB' },
	property: { color: '#7ADBF1' },
	tag: { color: '#7ADBF1' },
	boolean: { color: '#7ADBF1' },
	number: { color: '#7ADBF1' },
	constant: { color: '#7ADBF1' },
	symbol: { color: '#7ADBF1' },
	deleted: { color: '#F95E5E' },
	selector: { color: '#40D48E' },
	'attr-name': { color: '#40D48E' },
	string: { color: '#40D48E' },
	char: { color: '#40D48E' },
	builtin: { color: '#40D48E' },
	inserted: { color: '#40D48E' },
	operator: { color: '#E5E7EB' },
	entity: { color: '#E5E7EB', cursor: 'help' },
	url: { color: '#7ADBF1' },
	'attr-value': { color: '#40D48E' },
	keyword: { color: '#5574FF' },
	atrule: { color: '#5574FF' },
	function: { color: '#7ADBF1' },
	'class-name': { color: '#7ADBF1' },
	regex: { color: '#F0BF47' },
	important: { color: '#F95E5E', fontWeight: 'bold' },
	variable: { color: '#E5E7EB' },
	bold: { fontWeight: 'bold' },
	italic: { fontStyle: 'italic' },
};
